export default __webpack_public_path__ + "fonts/fix-and-flip-icon.svg";